module.exports = __webpack_public_path__ + "img/Flag_of_Sao_Tome_and_Principe.0ed70ad4.svg";